/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-16 18:14:18
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-08-31 13:54:45
 * @name: 挂载全局工具方法
 * @Description: 挂载全局工具方法
 * @FilePath: \preSaleNafterSaleBackstage\src\utils\common.js
 * @Author: DESKTOP-1QU67QM
 */
import { Loading } from 'element-ui';

const common = {
  // 加载中
  loading: (text) => {
    return Loading.service({
      lock: true,
      text,
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
  }
}

export default common;